import React, { Component } from 'react';
import { resetPassword, resetFailed, clearError } from './ducks/actions';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Alert, Row, Col, ControlLabel } from 'react-bootstrap';
import './style.css';
class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      birthday: '',
      serial_number: '',
      password: '',
      confirm_password: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.isValid = this.isValid.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
  }
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  isValid() {
    console.log(this.state.birthday);
    if (!this.state.birthday) {
      this.props.actions.resetFailed('Please enter you birthday');
      return false;
    }
    if (this.state.serial_number.length < 4) {
      this.props.actions.resetFailed(
        'Last 4 of social must be at least 4 numbers'
      );
      return false;
    }
    if (this.state.password !== this.state.confirm_password) {
      this.props.actions.resetFailed('Passwords do not match');
      return false;
    }
    if (this.state.password.length < 8) {
      this.props.actions.resetFailed(
        'Password must be at least 8 characters long'
      );
      return false;
    }
    return true;
  }

  handleDismiss() {
    this.props.actions.clearError();
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.isValid()) {
      this.props.actions.resetPassword(
        this.props.match.params.token,
        this.state.birthday,
        this.state.serial_number,
        this.state.password
      );
    }
  }

  render() {
    if (this.props.token) {
      return <Redirect to="/paystubs" />;
    }
    var errorMessage;
    if (this.props.error) {
      errorMessage = (
        <div className="row">
          <div className="col-sm-12">
            <Alert bsStyle="danger" onDismiss={this.handleDismiss}>
              {this.props.error}
            </Alert>
          </div>
        </div>
      );
    }
    return (
      <div className="main-wrapper">
        <form onSubmit={this.handleSubmit} className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">Reset Password</h3>
          </div>
          <div className="panel-body">
            {errorMessage}
            <Row>
              <Col xs={12} className="form-group">
                <ControlLabel>Create New Password</ControlLabel>
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="fa fa-fw fa-key" />
                  </div>
                  <input
                    className="form-control"
                    placeholder="Enter New Password"
                    type="password"
                    name="password"
                    value={this.state.password}
                    onChange={this.handleChange}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="form-group">
                <ControlLabel>Confirm New Password</ControlLabel>
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="fa fa-fw fa-key" />
                  </div>
                  <input
                    className="form-control"
                    placeholder="Confirm Password"
                    type="password"
                    name="confirm_password"
                    value={this.state.confirm_password}
                    onChange={this.handleChange}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="form-group">
                <ControlLabel>Birthday</ControlLabel>
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="fa fa-fw fa-birthday-cake" />
                  </div>
                  <input
                    className="form-control"
                    type="date"
                    name="birthday"
                    value={this.state.birthday}
                    onChange={this.handleChange}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="form-group">
                <ControlLabel>Verify Last 4 Digits of SSN</ControlLabel>
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="fa fa-fw fa-address-card-o" />
                  </div>
                  <input
                    className="form-control"
                    placeholder="Enter Last 4 of Social"
                    type="text"
                    name="serial_number"
                    value={this.state.serial_number}
                    onChange={this.handleChange}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <input
                  className="btn btn-lg btn-primary btn-block"
                  type="submit"
                  value="Login"
                />
              </Col>
            </Row>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.resetPasswordReducer.error,
    token: state.resetPasswordReducer.token
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      resetPassword: (token, birthday, serial_number, secret) => {
        dispatch(resetPassword(token, birthday, serial_number, secret));
      },
      resetFailed: message => {
        dispatch(resetFailed(message));
      },
      clearError: () => {
        dispatch(clearError());
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/account/ResetPassword/index.js